<div #logo class="flex items-center opacity-0" tabindex="0" (click)="restartNavigation()" (keypress.enter)="restartNavigation()">
    <img class="h-8"
        [class]="!hasViewId ? 'cursor-pointer' : ''"
        alt="Logo"
        [src]="logoSrc"
        [attr.aria-label]="logoTitle() + ' Logo'"
    >
</div>